export class ChatBotPositioningService {
    getChatBotWindowPosition = () => {
        if (localStorage.getItem('chatbotAi.chat-position') !== null) {
            return JSON.parse(localStorage.getItem('chatbotAi.chat-position'));
        }

        return null;
    }

    setChatBotWindowPosition = (position) => {
        localStorage.setItem('chatbotAi.chat-position', JSON.stringify(position));
    }

    isChatBotFirstTimeOpened = () => {
        if (localStorage.getItem('chatBot.first-time-open') === null) {
            return true;
        }

        return false;
    }

    setChatBotFirstTimeOpened = () => {
        localStorage.setItem('chatBot.first-time-open', true);
    }
}
